import { get, post, put, remove, handleClientError } from '../lib'

import { DataSetBody, DataSetUpdateBody } from '../../pages/Datasets/types'

interface ResponseType {
  id: string
  name: string
  description: string
  type: string
  filter: {
    type: string
    value: number[] | string[] | string
  }[]
  user: {
    id: number
    name: string
  }
  allow_edit: boolean
  allow_delete: boolean
  created_at: string
  updated_at: string
}

export interface DatasetFile {
  filepath: string
  size: number
  last_modified: string
  data: {
    vehicle: string
    id: number
    startDate: string
    vehicleId: number
    deviceId: number
    uploadId: number
    fileName: string
  }
}

export const getAllDatasets = async (): Promise<ResponseType[]> => {
  return get<ResponseType[]>({
    path: '/ipa/dataset'
  })
}

export const createDataset = async (
  body: DataSetBody
): Promise<DataSetBody> => {
  return post<DataSetBody, DataSetBody>({
    path: '/ipa/dataset',
    body
  })
}

export const getDataset = async (id: string): Promise<ResponseType> => {
  return get<ResponseType>({
    path: `/ipa/dataset/${id}`
  })
}

export const getDatasetFiles = async (id: string): Promise<DatasetFile[]> => {
  return get<DatasetFile[]>({
    path: `/ipa/dataset/${id}/files`
  })
}

export const updateDataset = async (data: {
  id: string
  body: DataSetUpdateBody
}): Promise<DataSetUpdateBody> => {
  return put<DataSetUpdateBody, DataSetUpdateBody>({
    path: `/ipa/dataset/${data.id}`,
    body: data.body
  })
}

export const removeDataset = async (id: string): Promise<null> => {
  return remove({
    path: '/ipa/dataset',
    id
  })
}
